<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-container v-if="true">
    <v-layout
      v-if="display_advanved_filters_applied.items.length > 0"
      class="ml-0 mr-1"
      row
    >
      <span class="result_box_no_border mt-1 mr-2 pa-0">
        <v-tooltip left>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-on="on" @click="$store.commit('toggleProductsFilter', true)"
              >mdi-dolly</v-icon
            >
          </template>
          <span>Click to open product filters</span>
        </v-tooltip>
      </span>

      <v-flex
        v-if="
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META
            .report_type_to_generate !== '1PMC'
        "
        class="mt-1 ml-4"
      >
        <v-expansion-panels class="ma-0 pa-0">
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-header class="ma-o pa-0">
              <template v-slot:default="{open}">
                <v-row v-if="open" class="justify-space-between align-center">
                  <v-flex class="ml-9" sm10>
                    <span class="ma-0 pa-0 ml-1"
                      >{{
                        $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                          .products.HS6_Code.length > 0
                          ? 'Selected'
                          : 'Filtered'
                      }}
                      products
                    </span>
                    <v-btn
                      x-small
                      text
                      @click.prevent="
                        html_to_xls_download('results_current_products');
                        open = true;
                      "
                    >
                      <v-icon class="green--text">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex> </v-flex>
                </v-row>

                <span v-else class="ml-2"
                  >Click to view
                  {{
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                      .products.HS6_Code.length > 0
                      ? 'selected'
                      : 'filtered'
                  }}
                  products ({{
                    $store.getters.selectionCounts.results.products_count
                  }})</span
                >
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <v-data-table
                id="results_current_products"
                :headers="display_advanved_filters_applied['headers']"
                :items="display_advanved_filters_applied['items']"
                :items-per-page="5"
                class="elevation-1 ma-0 pa-0"
                dense
                :footer-props="{
                  'items-per-page-options': calc_items_per_page(
                    display_advanved_filters_applied['items'].length,
                    4,
                    $store.state.user.userServerInfo.app_config.max_products,
                  ),
                }"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
      <v-flex v-else class="green--text mb-2 sm11 ml-2">
        <span>
          <v-tooltip left>
            <template v-slot:activator="{on, attrs}">
              <span>
                <a
                  :href="itc_products_url"
                  target="_blank"
                  class="align-center"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-img
                    class="d-inline-block mb-auto mt-auto"
                    contain
                    max-width="40"
                    src="../../../assets/img/itc-logo.gif"
                  ></v-img
                ></a>
                [{{ single_product }}] {{ hs6_codeToDescription(single_product) }}
              </span>
            </template>
            <span>Click to view ITC tariff information</span>
          </v-tooltip>
        </span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';

const {csvExport} = require('@/components/application-level/js_functions/jsFunctions');
const {
  html_to_xls_download,
} = require('@/components/application-level/js_functions/jsFunctions');
import {mapGetters} from 'vuex';

const {
  calc_items_per_page,
} = require('@/components/trade-dsm-application/mixins/calc_items_per_page');

export default {
  name: 'products_filtered_box',
  methods: {
    csv: csvExport,
    calc_items_per_page: calc_items_per_page,
    html_to_xls_download: html_to_xls_download,
  },
  computed: {
    ...mapGetters(['single_product']),
    display_advanved_filters_applied() {
      let items = _.cloneDeep(
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
          .products,
      ).map(v => {
        return [
          {
            HS6_Code: v,
            HS6_Description: this.$store.state.tradeDSM.hs6_to_desc_hash_map[v],
          },
        ][0];
      });

      let headers = [
        {
          text: 'Products Code (HS6)',
          value: 'HS6_Code',
          class: 'table_header_color',
        },
        {
          text: 'Product Description',
          value: 'HS6_Description',
          class: 'table_header_color',
        },
      ];

      return {
        headers: headers,
        items: items,
      };
    },

    itc_products_url() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code !== undefined &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        const code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0].slice(
          2,
        );

        return `https://legacy.trademap.org/stCorrespondingProductCodes.aspx?nvpm=1%7c%7c%7c%7c%7c${code}%7c%7c%7c%7c%7c%7c%7c2%7c%7c%7c%7c%7c1`;
      } else return '';
    },
  },
};
</script>

<style scoped></style>
